/*
 This file was auto-generated from config/recipes/templates/bl_admin/constants.js.erb
 DO NOT directly edit this file.
*/

export const CONFIG = {
  "products": {
    "productTypes": [
      "virtual_service_fee",
      "digital",
      "external",
      "drop_ship",
      "drop_ship_edi",
      "favor",
      "group_gift_contribution",
      "inventory",
      "hello_baby_box",
      "generated_from_reg_item",
      "physical_gift_card",
      "universal",
      "virtual_bundle"
    ],
    "externalProductTypes": [
      "external",
      "generated_from_reg_item",
      "universal"
    ],
    "singleProductTypes": [
      "external",
      "generated_from_reg_item"
    ],
    "taxCategories": [
      {
        "name": "Antibacterial Soap Only",
        "code": "PH400826"
      },
      {
        "name": "Baby Oil",
        "code": "PI040594"
      },
      {
        "name": "Baby Supplies - Bedding",
        "code": "PI041073"
      },
      {
        "name": "Baby Supplies - Carriers",
        "code": "PI041078"
      },
      {
        "name": "Baby Supplies - Furniture & Accessories",
        "code": "PI041076"
      },
      {
        "name": "Baby Supplies - Grooming",
        "code": "PI041077"
      },
      {
        "name": "Baby Supplies - Safety Items",
        "code": "PI041075"
      },
      {
        "name": "Baby Supplies - Strollers",
        "code": "PI041079"
      },
      {
        "name": "Baby Supplies - Strollers and Car Seats sold as a Single Unit",
        "code": "PI041080"
      },
      {
        "name": "Baby Products",
        "code": "PI040597"
      },
      {
        "name": "Bath Products",
        "code": "PH400834"
      },
      {
        "name": "Baby Wipes",
        "code": "PH050532"
      },
      {
        "name": "Breast Feeding:  Breast Milk Bottles and Breast Milk Storage Bottles",
        "code": "PH403700"
      },
      {
        "name": "Books",
        "code": "PB100000"
      },
      {
        "name": "Breast Feeding: Breast Milk Storage Bags / Breast Cream (Lanolin) / Softcup Feeders / Finger Feeders / Haberman Feeders / Supplemental Nursing Systems / Periodontal Syringes",
        "code": "PH403699"
      },
      {
        "name": "Breast Pump",
        "code": "PH403698"
      },
      {
        "name": "Child Car Seats & Restraints",
        "code": "PC020000"
      },
      {
        "name": "Cleaning Products",
        "code": "PC010000"
      },
      {
        "name": "Cloth Diapers",
        "code": "PI041082"
      },
      {
        "name": "Cloth Nursing Pads (Washable)",
        "code": "PI041106"
      },
      {
        "name": "Clothing & related products (B2C) - General",
        "code": "PC040100"
      },
      {
        "name": "Clothing & related products (B2C) - Nursing Bras",
        "code": "PC041098"
      },
      {
        "name": "Clothing & related products (B2C) - Other",
        "code": "PC040600"
      },
      {
        "name": "Clothing And Related Products - Childrens Clothing (below age 11)",
        "code": "PC040501"
      },
      {
        "name": "Clothing And Related Products - Childrens Footwear (below age 11)",
        "code": "PC040503"
      },
      {
        "name": "Clothing and related products (business to consumer) / infant and toddler clothing and footwear / ages 5 years or less",
        "code": "PC040610"
      },
      {
        "name": "Covers",
        "code": "PH402842"
      },
      {
        "name": "Crib Blankets",
        "code": "PI041074"
      },
      {
        "name": "Diapers - baby",
        "code": "PH402850"
      },
      {
        "name": "Diaper rash ointments without zinc",
        "code": "PI040601"
      },
      {
        "name": "Diaper rash ointments with zinc",
        "code": "PI040610"
      },
      {
        "name": "Digital goods: videos-streaming / electronic download",
        "code": "DV010200"
      },
      {
        "name": "Equipment: Humidifier / Dehumidifier",
        "code": "PH403683"
      },
      {
        "name": "Gift Certificates",
        "code": "PG050000"
      },
      {
        "name": "Infant Supplies - bibs",
        "code": "PI040600"
      },
      {
        "name": "Lotions - Non-Medicated (Without Sunscreen)",
        "code": "PH400994"
      },
      {
        "name": "Medical Service",
        "code": "SH020400"
      },
      {
        "name": "Health care products-durable medical equipment-home use with a prescription",
        "code": "PH050208"
      },
      {
        "name": "Breast pump for home use with a prescription",
        "code": "PH403692"
      },
      {
        "name": "Non-Medicated Baby Powder",
        "code": "PI040578"
      },
      {
        "name": "Over-the-Counter medicinal products - First aid kits",
        "code": "PH050676"
      },
      {
        "name": "Packaging and Supplies",
        "code": "PA200522"
      },
      {
        "name": "Receiving Blankets",
        "code": "PC031114"
      },
      {
        "name": "Repair and replacement parts for breast pump kit which are for single patient use",
        "code": "PH403729"
      },
      {
        "name": "Shampoos & Conditioners - Non-Medicated",
        "code": "PH401002"
      },
      {
        "name": "Skin Care Kits",
        "code": "PH401010"
      },
      {
        "name": "Sun Blocks And Sun Screens",
        "code": "PH401019"
      },
      {
        "name": "Sunglasses without prescription",
        "code": "PH050461"
      },
      {
        "name": "Tangible Personal Property",
        "code": "P0000000"
      },
      {
        "name": "Thermometer",
        "code": "PH403898"
      },
      {
        "name": "Thermometer - Disposable",
        "code": "PH400044"
      }
    ]
  },
  "productReportingCategories": [
    {
      "id": 175,
      "name": "Apparel - Apparel Accessories"
    },
    {
      "id": 112,
      "name": "Apparel - Bandana Bibs"
    },
    {
      "id": 2,
      "name": "Apparel - Bodysuits"
    },
    {
      "id": 182,
      "name": "Apparel - Dresses & Rompers"
    },
    {
      "id": 183,
      "name": "Apparel - Family Pajamas"
    },
    {
      "id": 185,
      "name": "Apparel - Footies"
    },
    {
      "id": 186,
      "name": "Apparel - Gift Sets"
    },
    {
      "id": 121,
      "name": "Apparel - Gowns"
    },
    {
      "id": 5,
      "name": "Apparel - Outerwear"
    },
    {
      "id": 12,
      "name": "Apparel - Outfit Sets"
    },
    {
      "id": 196,
      "name": "Apparel - Separates"
    },
    {
      "id": 115,
      "name": "Apparel - Shoes & Booties"
    },
    {
      "id": 13,
      "name": "Apparel - Swimwear"
    },
    {
      "id": 200,
      "name": "Apparel - Toddler Apparel"
    },
    {
      "id": 15,
      "name": "Bags - Diaper Bags"
    },
    {
      "id": 16,
      "name": "Bags - Pumping Bags"
    },
    {
      "id": 202,
      "name": "Bags - Travel Accessories"
    },
    {
      "id": 125,
      "name": "Books & Keepsakes - Book Sets"
    },
    {
      "id": 127,
      "name": "Books & Keepsakes - Books for Parents"
    },
    {
      "id": 181,
      "name": "Books & Keepsakes - Childrens Books"
    },
    {
      "id": 190,
      "name": "Books & Keepsakes - Keepsakes"
    },
    {
      "id": 61,
      "name": "Books & Keepsakes - Photo Books & Journals"
    },
    {
      "id": 130,
      "name": "Breast Pumps - Breast Pump Accessories"
    },
    {
      "id": 129,
      "name": "Breast Pumps - Breast Pumps"
    },
    {
      "id": 24,
      "name": "Car Seats - Boosters"
    },
    {
      "id": 23,
      "name": "Car Seats - Car Seat Accessories"
    },
    {
      "id": 25,
      "name": "Car Seats - Convertible Car Seat"
    },
    {
      "id": 26,
      "name": "Car Seats - Infant Car Seat"
    },
    {
      "id": 208,
      "name": "Carriers - Carrier Accessories"
    },
    {
      "id": 207,
      "name": "Carriers - Hybrid Carriers"
    },
    {
      "id": 27,
      "name": "Carriers - Soft Carriers"
    },
    {
      "id": 28,
      "name": "Carriers - Structured Carriers"
    },
    {
      "id": 65,
      "name": "Consumables - Cleaning & Laundry"
    },
    {
      "id": 34,
      "name": "Consumables - Diaper Creams"
    },
    {
      "id": 32,
      "name": "Consumables - Diapers"
    },
    {
      "id": 187,
      "name": "Consumables - Grooming"
    },
    {
      "id": 209,
      "name": "Consumables - Nursing & Pumping Accessories"
    },
    {
      "id": 145,
      "name": "Consumables - Postpartum Care"
    },
    {
      "id": 210,
      "name": "Consumables - Shampoos & Lotions"
    },
    {
      "id": 203,
      "name": "Consumables - Vitamins & Supplements"
    },
    {
      "id": 35,
      "name": "Consumables - Wipes"
    },
    {
      "id": 36,
      "name": "Diapering & Potty - Changing Pads"
    },
    {
      "id": 31,
      "name": "Diapering & Potty - Cloth Diapers"
    },
    {
      "id": 37,
      "name": "Diapering & Potty - Diaper Pails"
    },
    {
      "id": 30,
      "name": "Diapering & Potty - Diapering Accessories"
    },
    {
      "id": 33,
      "name": "Diapering & Potty - Potty Training"
    },
    {
      "id": 50,
      "name": "Feeding - Baby Food Makers"
    },
    {
      "id": 43,
      "name": "Feeding - Bottle Accessories"
    },
    {
      "id": 211,
      "name": "Feeding - Bottle Brushes"
    },
    {
      "id": 132,
      "name": "Feeding - Bottle Warmers & Sterilizers"
    },
    {
      "id": 42,
      "name": "Feeding - Bottles"
    },
    {
      "id": 131,
      "name": "Feeding - Breast Feeding Accessories"
    },
    {
      "id": 133,
      "name": "Feeding - Drinking Cups"
    },
    {
      "id": 184,
      "name": "Feeding - Feeding Bibs"
    },
    {
      "id": 46,
      "name": "Feeding - Formula Feeding"
    },
    {
      "id": 192,
      "name": "Feeding - Nursing/Prenatal Pillows"
    },
    {
      "id": 40,
      "name": "Feeding - Pacifiers"
    },
    {
      "id": 48,
      "name": "Feeding - Solid Feeding"
    },
    {
      "id": 199,
      "name": "Feeding - Teethers"
    },
    {
      "id": 54,
      "name": "Furniture - Book Shelves"
    },
    {
      "id": 58,
      "name": "Furniture - Chairs"
    },
    {
      "id": 55,
      "name": "Furniture - Changing Tables"
    },
    {
      "id": 57,
      "name": "Furniture - Cribs"
    },
    {
      "id": 56,
      "name": "Furniture - Dressers"
    },
    {
      "id": 78,
      "name": "Furniture - Mattresses"
    },
    {
      "id": 59,
      "name": "Furniture - Tables"
    },
    {
      "id": 108,
      "name": "Gift Cards - Gift Cards"
    },
    {
      "id": 173,
      "name": "HBB - HBB"
    },
    {
      "id": 66,
      "name": "Health & Safety - Baby Proofing"
    },
    {
      "id": 176,
      "name": "Health & Safety - Bath Accessories"
    },
    {
      "id": 178,
      "name": "Health & Safety - Bath Tubs"
    },
    {
      "id": 212,
      "name": "Health & Safety - Birth Prep"
    },
    {
      "id": 68,
      "name": "Health & Safety - First Aid"
    },
    {
      "id": 75,
      "name": "Health & Safety - Hearing Protection"
    },
    {
      "id": 213,
      "name": "Health & Safety - Humidifiers & Air Purifiers"
    },
    {
      "id": 188,
      "name": "Health & Safety - Humidifiers, Soothers & Sound Machines"
    },
    {
      "id": 197,
      "name": "Health & Safety - Shampoo & Lotion"
    },
    {
      "id": 136,
      "name": "Health & Safety - Thermometers"
    },
    {
      "id": 140,
      "name": "High Chairs - Convertible High Chairs"
    },
    {
      "id": 142,
      "name": "High Chairs - High Chair Accessories"
    },
    {
      "id": 141,
      "name": "High Chairs - Portable High Chairs"
    },
    {
      "id": 47,
      "name": "High Chairs - Traditional High Chairs"
    },
    {
      "id": 117,
      "name": "Maternity - Maternity Apparel"
    },
    {
      "id": 122,
      "name": "Maternity - Maternity Intimates"
    },
    {
      "id": 51,
      "name": "Maternity - Nursing Covers"
    },
    {
      "id": 148,
      "name": "Monitors - Monitor Accessories"
    },
    {
      "id": 147,
      "name": "Monitors - Smart Monitors"
    },
    {
      "id": 72,
      "name": "Monitors - Standard Monitors"
    },
    {
      "id": 80,
      "name": "Nursery & Decor - Bassinets & Bedside Sleepers"
    },
    {
      "id": 79,
      "name": "Nursery & Decor - Loungers & Co-Sleepers"
    },
    {
      "id": 191,
      "name": "Nursery & Decor - Nursery Decor"
    },
    {
      "id": 84,
      "name": "Nursery & Decor - Soothers & Sound Machines"
    },
    {
      "id": 85,
      "name": "Nursery & Decor - Storage & Organization"
    },
    {
      "id": 174,
      "name": "Packaging - Packaging"
    },
    {
      "id": 93,
      "name": "Play & Activity - Activity Centers"
    },
    {
      "id": 88,
      "name": "Play & Activity - Bouncers"
    },
    {
      "id": 94,
      "name": "Play & Activity - Infant Seats"
    },
    {
      "id": 95,
      "name": "Play & Activity - Jumpers"
    },
    {
      "id": 92,
      "name": "Play & Activity - Play Gyms"
    },
    {
      "id": 96,
      "name": "Play & Activity - Play Mats"
    },
    {
      "id": 150,
      "name": "Play & Activity - Play Tables & Chairs"
    },
    {
      "id": 193,
      "name": "Play & Activity - Playard Accessories & Sheets"
    },
    {
      "id": 91,
      "name": "Play & Activity - Playards & Portable Beds"
    },
    {
      "id": 89,
      "name": "Play & Activity - Swings"
    },
    {
      "id": 201,
      "name": "Play & Activity - Toddler Play"
    },
    {
      "id": 90,
      "name": "Play & Activity - Walkers"
    },
    {
      "id": 194,
      "name": "Premium Kits - Premium Kits"
    },
    {
      "id": 101,
      "name": "Strollers - Double Strollers"
    },
    {
      "id": 151,
      "name": "Strollers - Jogging Strollers"
    },
    {
      "id": 102,
      "name": "Strollers - Single Strollers"
    },
    {
      "id": 99,
      "name": "Strollers - Stroller Accessories"
    },
    {
      "id": 152,
      "name": "Strollers - Stroller Frames & Caddies"
    },
    {
      "id": 100,
      "name": "Strollers - Travel Systems"
    },
    {
      "id": 153,
      "name": "Strollers - Umbrella / Travel Strollers"
    },
    {
      "id": 204,
      "name": "Strollers - Wagons"
    },
    {
      "id": 177,
      "name": "Textiles & Softlines - Bath Textiles"
    },
    {
      "id": 179,
      "name": "Textiles & Softlines - Bedding"
    },
    {
      "id": 39,
      "name": "Textiles & Softlines - Burp Cloths"
    },
    {
      "id": 158,
      "name": "Textiles & Softlines - Changing Pad Covers"
    },
    {
      "id": 170,
      "name": "Textiles & Softlines - Crib Sheets"
    },
    {
      "id": 162,
      "name": "Textiles & Softlines - Mattress Pads and Liners"
    },
    {
      "id": 198,
      "name": "Textiles & Softlines - Sheets"
    },
    {
      "id": 103,
      "name": "Textiles & Softlines - Swaddle Blankets"
    },
    {
      "id": 157,
      "name": "Textiles & Softlines - Toddler Bedding"
    },
    {
      "id": 205,
      "name": "Textiles & Softlines - Wearable Swaddles"
    },
    {
      "id": 169,
      "name": "Toys - Bath Toys"
    },
    {
      "id": 180,
      "name": "Toys - Bikes & Ride-Ons"
    },
    {
      "id": 168,
      "name": "Toys - Car Seat & Stroller Toys"
    },
    {
      "id": 189,
      "name": "Toys - Infant Toys"
    },
    {
      "id": 167,
      "name": "Toys - Plush Toys"
    },
    {
      "id": 195,
      "name": "Toys - Rattles"
    },
    {
      "id": 166,
      "name": "Toys - Toddler Toys"
    },
    {
      "id": 165,
      "name": "Toys - Toy Subscriptions"
    },
    {
      "id": 206,
      "name": "Toys - Wooden Toys"
    }
  ],
  "returns": {
    "returnReasonOther": "Other",
    "returnReasons": [
      "Too small",
      "Too large",
      "Bought by mistake",
      "Better price available",
      "Product damaged, but shipping box OK",
      "Item arrived too late",
      "Missing parts or accessories",
      "Product and shipping box both damaged",
      "Wrong item was sent",
      "Item defective or doesn't work",
      "Received extra item I didn't buy (no refund needed)",
      "Hello Baby Box order cancelled",
      "No longer needed",
      "Style not as expected",
      "Bought wrong size, style, or color",
      "Didn't approve purchase",
      "Inaccurate website description",
      "Already received gift",
      "Other"
    ],
    "returnTypeCredit": "credit",
    "returnTypeRefund": "refund",
    "returnTypes": [
      "credit",
      "refund"
    ]
  }
}
export const CONTENTFUL_SPACE_ID = '50gzycvace50'
export const PRODUCT_DIVISIONS = ["DIV_1","DIV_2","DIV_3","DIV_4","DIV_5","DIV_6","DIV_7","DIV_8","DIV_9","DIV_10"]
export const PRODUCT_OFFER_SOURCE_ADMIN = 'admin'
export const PRODUCT_TYPE_DIGITAL= 'digital'
export const PRODUCT_TYPE_DROP_SHIP = 'drop_ship'
export const PRODUCT_TYPE_DROP_SHIP_EDI = 'drop_ship_edi'
export const PRODUCT_TYPE_EXTERNAL = 'external'
export const PRODUCT_TYPE_FAVOR = 'favor'
export const PRODUCT_TYPE_GENERATED_FROM_REG_ITEM = 'generated_from_reg_item'
export const PRODUCT_TYPE_GROUP_GIFT_CONTRIBUTION = 'group_gift_contribution'
export const PRODUCT_TYPE_INVENTORY = 'inventory'
export const PRODUCT_TYPE_HELLO_BABY_BOX = 'hello_baby_box'
export const PRODUCT_TYPE_PHYSICAL_GIFT_CARD = 'physical_gift_card'
export const PRODUCT_TYPE_UNIVERSAL = 'universal'
export const PRODUCT_TYPE_VIRTUAL_BUNDLE = 'virtual_bundle'
export const PRODUCT_TYPE_VIRTUAL_SERVICE_FEE = 'virtual_service_fee'
export const SHOW_RETURN_MODAL_EVENT = 'returnModal.show'
export const CATALOG_CATEGORY_SORT_ORDERS = ["desc","asc"]
export const CATALOG_CATEGORY_SORT_TYPES = ["popular","reviews","rating","price","newest"]
export const BABYLIST_HEALTH_CATALOG = 'Babylist Health'
export const STORE_CATALOGS = ["Babylist", "Babylist Health", "Babylist Showroom"]
